var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 24,
    height: 24,
    fill: "#5e5e5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M354.583,282.183c.863,2.235.895,10.389-.109,12.548a2.759,2.759,0,0,1-1.281,1.292c-1.524.8-17.228.792-19.232.131a2.754,2.754,0,0,1-1.819-1.764c-.793-2.169-1.027-11.237.488-13.024a2.969,2.969,0,0,1,1.983-1.049c4.1-.444,16.729-.381,18.183.147A2.824,2.824,0,0,1,354.583,282.183Zm-6.767,5.905c-2.472-1.289-4.9-2.564-7.359-3.848V291.9C342.912,290.627,345.354,289.362,347.816,288.088Z",
    transform: "translate(-331.518 -280.022)",
    fill: "#5e5e5e"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGray);
export default __webpack_public_path__ + "static/media/youtubeGray.23542280d0b1b2239c2dc56d5d881115.svg";
export { ForwardRef as ReactComponent };